import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    header: {
      fontSize: 12,
    },
    exportButton: {
      background: palette.navCompanyContextActions,
      color: palette.white,
      marginLeft: 16,
      height: 30,
      padding: '5px 12px',

      '&:hover': {
        background: palette.navCompanyContextActions,
      },
    },
    exportButtonGray: {
      background: palette.navSuperAdminActions,
      color: palette.white,
      marginLeft: 16,

      '&:hover': {
        background: palette.navSuperAdminActions,
      },
    },
    exportButtonBlue: {
      background: palette.navOperatorActions,
      color: palette.white,
      marginLeft: 16,

      '&:hover': {
        background: palette.navOperatorActions,
      },
    },
    exportButtonGreen: {
      background: palette.navAdminActions,
      color: palette.white,
      marginLeft: 16,

      '&:hover': {
        background: palette.navAdminActions,
      },
    },
    iconButton: {
      textAlign: 'end',
    },
  });
